import { module } from 'modujs';
import modularLoad from '../utils/load';
import { html } from '../utils/environment'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        window.scrollTo(0, 0);

        this.load = new modularLoad({
            enterDelay: 600,
            transitions: {
                filter: {
                    enterDelay: 400
                },
                form: {
                    enterDelay: 400
                }
            }
        });

        this.load.on('loaded', (transition, oldContainer, newContainer) => {
            html.classList.remove('has-scrolled')

            this.call('destroy', oldContainer, 'app');
            this.call('update', newContainer, 'app');


            if(transition === 'filter') {
                this.call('resetScrollInstance', null, 'Scroll')
                this.call('setFormData', null, 'ProductFilters')
            }

            if(transition === 'form') {
                this.call('resetScrollInstance', null, 'Scroll')

                const breadcrumbHTML = newContainer.querySelector('#breadcrumb-form')?.innerHTML;
                const breadcrumb = document.getElementById('breadcrumb');

                if(breadcrumbHTML.length > 0 && breadcrumb) {
                    breadcrumb.innerHTML = breadcrumbHTML
                }

                requestAnimationFrame(()=>{
                    this.call('scrollTo', [newContainer, { offset: -300, duration: 300 }], 'Scroll')
                })
            }
            document.querySelectorAll("script.js-inline").forEach((e)=>{
                console.log(e.innerHTML)
                eval(e.innerHTML)
            })
        });

        this.load.on('loading', (transition, oldContainer) => {
            html.classList.remove('has-nav-sticky-show')
            this.call('close', null, 'Menu');
            this.call('close', null, 'SelectOverlay')
            this.call('close', null, 'Aside')

            if(transition === 'filter') {
                this.call('scrollTo', [oldContainer, { offset: -300, duration: 300 }], 'Scroll')
            }
        });
    }

    goTo(obj) {
        this.load.goTo(obj.url, obj.transition);
    }
}
